module.exports = __webpack_public_path__ + "img/text-medium.204ab777.svg";